export default [
  {
    title: 'DashBoard',
    icon: 'HomeIcon',
    tagVariant: 'light-warning',
    route: 'dashboard',
  },
]
